<template>
  <div>
    <el-dialog
      title="Dodaj nowy widget"
      width="80vw"
      :visible.sync="dialogFormVisible"
      append-to-body
    >
      <transition name="slide-left">
        <select-widget-type
          v-if="step === 1"
          @widgetSelected="widgetSelected"
          :hiddenWidgets="hiddenWidgets"
        />
        <div v-else-if="step === 2">
          <widget-form
            v-if="form"
            :widget="form"
            @submit="addWidget"
            @cancel="closeDialog"
          />
        </div>
      </transition>
    </el-dialog>
  </div>
</template>
<script>
import { groupBy, orderBy } from 'lodash'
import WidgetForm from '@/components/widgets/widgetFormDialog/Form'
import SelectWidgetType from './SelectWidgetType'

export default {
  props: {
    hiddenWidgets: Array
  },
  data() {
    return {
      step: 1,
      dialogFormVisible: false,
      widgetRow: 0,
      widgetCol: 0,
      form: null
    }
  },
  components: {
    SelectWidgetType,
    WidgetForm
  },
  computed: {
    groupedWidgets() {
      const sortedTypes = orderBy(
        this.$store.state.widgetTypes,
        ['group'],
        ['desc']
      )
      return groupBy(sortedTypes, 'group')
    },
    getWidgetType() {
      return this.$store.getters.getWidgetByResourcetype
    }
  },
  methods: {
    widgetSelected(resourcetype) {
      // fill form with base widget data
      this.step = 2
      const dimensions = this.getWidgetType(resourcetype).dimensions
      const chars = [...'abcdefghijklmnopqrstuvwxyz']
      const i = [...Array(6)]
        .map(i => chars[(Math.random() * chars.length) | 0])
        .join('')

      const defaultFullWidth = ['TextWidget', 'QuotationWidget'].includes(
        resourcetype
      )

      this.form = {
        resourcetype,
        w: defaultFullWidth ? dimensions.MAX_COLS : dimensions.MIN_COLS,
        h: dimensions.MIN_ROWS,
        y: this.widgetRow,
        x: this.widgetCol,
        i
      }
    },
    openDialog(widgetRow, widgetCol) {
      this.dialogFormVisible = true
      this.widgetRow = widgetRow || 0
      this.widgetCol = widgetCol || 0
      this.step = 1
    },
    closeDialog() {
      this.step = 1
      this.form = null
      this.dialogFormVisible = false
    },
    addWidget(form) {
      this.$emit('addWidget', form)
      this.closeDialog()
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog {
  overflow: hidden;
}
</style>
